import { ArticleDto } from './article.dto';

export class ArticleUpdateDto extends ArticleDto {}
